import React, { useEffect } from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import { Link } from "react-router-dom";
function FeeStructure() {
  useEffect(() => {
    document.title = "Staff Members-  CARMEL CONVENT SCHOOL, DHARUHERA";
  }, []);
  return (
    <>
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li>
                  <Link to="/"> Home </Link>
                </li>
                <li>Academics</li>
                <li>Fee Structure</li>
              </ul>
            </div>
            <div className="col-lg-12">
              <h2 className="innerheading">Fee Structure</h2>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-12">


              <div className="table-responsive maintable mb-5">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Class</th>
                      <th>Registration Fee (New admission)</th>
                      <th>Admission Fee (New admission)</th>
                      <th>Monthly Composite Fee</th>
                      <th>Total Annual fee</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Nursery, Lkg & U.KG</td>
                      <td>Rs. 200</td>
                      <td>Rs.10000</td>
                      <td>Rs.4200</td>
                      <td>Rs. 60600</td>
                    </tr>
                    <tr>
                      <td>1st to 5th</td>
                      <td>Rs.200</td>
                      <td>Rs.10000</td>
                      <td>Rs.4700</td>
                      <td>Rs. 66600</td>
                    </tr>
                    <tr>
                      <td>6th</td>
                      <td>Rs.200</td>
                      <td>Rs.10000</td>
                      <td>Rs.5000</td>
                      <td>Rs. 70200</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <h5 className="mb-3">DOCUMENTS REQUIRED FOR NEW ADMISSION</h5>

              <h5>Nursery</h5>
              <ul className="mainlist">
                <li>3 passport-size photographs of the child</li>
                <li>5”X3” size family photograph (child with both parents).</li>
                <li>Photocopy of the Birth Certificate.</li>
                <li>Aadhaar Card photocopy of the child.</li>
                <li>Aadhaar Card photocopies of both parents.</li>
              </ul>

              <h5>Classes L.Kg - VI:</h5>
              <ul className="mainlist">
                <li>3 passport-size photographs of the child</li>
                <li>5”X3” size family photograph (child with both parents).</li>
                <li>Aadhaar Card photocopy of the child.</li>
                <li>Aadhaar Card photocopies of both parents.</li>
                <li>Original Transfer Certificate (TC)</li>
                <li>Photocopy of the previous class Report Card.</li>
              </ul>

              <h5 className="mb-3 mt-5">INSTRUCTIONS</h5>

              <ul className="mainlist">
                <li>
                  Fill in the admission form carefully and neatly, ensuring that the child’s name and parents’ names are entered exactly as they appear on the Birth Certificate & Transfer Certificate (TC)
                </li>
                <li>
                  Presence of both the parent’s is compulsory at the time of admission, as signature of both parents are required on the admission form.
                </li>
                <li>
                  Please bring all original documents along with their photocopies while submitting the admission form.
                </li>
                <li>
                  School Fee is payable quarterly in advance in April, July, October & January.
                </li>
                <li>
                  The last date for fee deposit is the 10th of each quarter month. A late fee of Rs.100/- per month will be charged thereafter.
                </li>
                <li>
                  Admission charges and all other charges are non-refundable.
                </li>
                <li>
                  If the cheque is dishonoured by the bank for any reason, an additional charge of Rs.500 will be charged.
                </li>
              </ul>

              <h5 className="mb-4 mt-5">Your child is eligible if born between -</h5>

              <div className="table-responsive maintable">
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Class</th>
                      <th>Date of Birth</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>NURSERY</td>
                      <td>1st April 2022 - 31st March 2023</td>
                    </tr>
                    <tr>
                      <td>L.KG</td>
                      <td>1st April 2021 - 31st March 2022</td>
                    </tr>
                    <tr>
                      <td>U.KG</td>
                      <td>1st April 2020- 31st March 2021</td>
                    </tr>
                    <tr>
                      <td>GRADE I</td>
                      <td>1st April 2019 - 31st March 2020</td>
                    </tr>
                    <tr>
                      <td>GRADE II</td>
                      <td>1st April 2018 - 31st March 2019</td>
                    </tr>
                    <tr>
                      <td>GRADE III</td>
                      <td>1st April 2017 - 31st March 2018</td>
                    </tr>
                    <tr>
                      <td>GRADE IV</td>
                      <td>1st April 2016- 31st March 2017</td>
                    </tr>
                    <tr>
                      <td>GRADE V</td>
                      <td>1st April 2015 - 31st March 2016</td>
                    </tr>
                    <tr>
                      <td>GRADE VI</td>
                      <td>1st April 2014- 31st March 2015</td>
                    </tr>
                  </tbody>
                </table>
              </div>

            </div>
          </div>

        </div>
      </div>
      <Footer />
    </>
  );
}

export default FeeStructure;
